import { render } from "./DegisLucky.vue?vue&type=template&id=126a0100&scoped=true"
import script from "./DegisLucky.vue?vue&type=script&lang=js"
export * from "./DegisLucky.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-126a0100"

export default script